export const telparkDocValidations = {
  telpark_totalamount_mismatch_amountincvat: `Total amount '{{0}}' does not match with sum of amount (inclusive vat) '{{1}}' of expense table`,
};
